import React, { PureComponent } from 'react'
import { Layer, Feature, Popup } from 'react-mapbox-gl'

const createMarkerStyle = props => ({
  'circle-radius': 8,
  'circle-stroke-color': '#FFFFFF',
  'circle-stroke-width': 2,
  ...props,
})

export default class Marker extends PureComponent {
  state = {
    showPopup: false,
  }

  showPopup = () => {
    this.setState({
      showPopup: true,
    })
  }

  hidePopup = () => {
    this.setState({
      showPopup: false,
    })
  }

  render() {
    const { flyTo, book, color, coordinates } = this.props
    return (
      <span>
        {this.state.showPopup && (
          <Popup
            coordinates={coordinates}
            offset={{
              'bottom-left': [12, -12],
              bottom: [0, -12],
              'bottom-right': [-12, -12],
            }}>
            Book {book.book_id.replace('twf-', '')}
          </Popup>
        )}
        <Layer
          type="circle"
          id={`marker-${book.id}`}
          paint={createMarkerStyle({ 'circle-color': color })}>
          <Feature
            coordinates={coordinates}
            onClick={() => flyTo(coordinates)}
          />
        </Layer>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Marker.js